var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'page-header',
    _vm.$activeLang,
    'position-relative',
    _vm.backgroundPosition ],style:(("background-image: url('" + _vm.cover + "')"))},[_c('div',{staticClass:"container d-flex justify-content-start align-items-center"},[_c('div',{staticClass:"page-info"},[_c('h2',{staticClass:"sec-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"sec-desc"},[_vm._v(" "+_vm._s(_vm.desc)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }